import type { ReactNode } from 'react';
import { SectionCard } from '../SectionCard';

/**
 * One card of the thread page's rail. On wide screens it is a plain
 * SectionCard in the sticky column; stacked above the discussion (below `lg`)
 * it becomes a collapsible `<details>` so the summary can stay open while the
 * ledger folds away with its counts in the header.
 */
export function RailCard({
  title,
  count,
  collapsible = false,
  defaultOpen = true,
  children,
}: {
  title: string;
  /** Shown next to the title (and as `data-count` for the ledger header). */
  count?: number;
  collapsible?: boolean;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  if (!collapsible) {
    return (
      <SectionCard title={title} count={count}>
        {children}
      </SectionCard>
    );
  }
  return (
    <details className="card overflow-hidden" open={defaultOpen}>
      <summary className="flex cursor-pointer list-none items-center justify-between gap-3 px-4 py-3 text-sm font-semibold text-ink [&::-webkit-details-marker]:hidden">
        <span>
          {title}
          {typeof count === 'number' && (
            <span className="ml-1.5 text-xs font-normal text-ink-faint" data-count={count}>
              {count}
            </span>
          )}
        </span>
        <span className="text-2xs font-normal uppercase tracking-wide text-ink-faint">toggle</span>
      </summary>
      <div className="border-t border-line p-4">{children}</div>
    </details>
  );
}
